import { Observable } from 'rxjs';
import { EntityModel } from '@bo-client/shared/models/entityModel';

export abstract class EntityService {
  baseUrl: string; // e.g. feeder-contract // uri.cmFeederContract

  abstract navigateToCreatePage(params: any);

  abstract navigateToEditPage(id: any);

  abstract loadData(
    id: string,
    master: string,
    number: number,
    number2: number,
    filterModel: { [p: string]: any },
    columnState: any
  ): Observable<{ content: EntityModel[]; totalElements: number }>;
}
